import type { FC } from 'react';
import clsx from 'clsx';

import { Box } from '@mui/material';
import { BiDotsVerticalRounded } from 'react-icons/bi';

import { OPopper } from '@src/shared';
import { useThreeDotsPopper } from './useThreeDotsPopper';

import style from './threeDotsPopper.module.scss';

const ThreeDotsPopper: FC = () => {
  const { isActive, setIsActive, menuItems } = useThreeDotsPopper();

  return (
    <OPopper
      tooltipContent="More"
      icon={
        <div className={`icon-container ${isActive ? 'active' : ''}`}>
          <BiDotsVerticalRounded size={24} />
        </div>
      }
      onClose={() => setIsActive(false)}
      onOpen={() => setIsActive(true)}
      offset={[0, 10]}
    >
      {menuItems.map(({ id, icon, label, onClick, className }) => (
        <Box key={id} id={id} onClick={onClick} className={clsx(className, style.item)}>
          {icon}
          {label}
        </Box>
      ))}
    </OPopper>
  );
};

export default ThreeDotsPopper;
